import { render } from "./AppPaymentsTable.vue?vue&type=template&id=51ed75a6&ts=true"
import script from "./AppPaymentsTable.vue?vue&type=script&lang=ts"
export * from "./AppPaymentsTable.vue?vue&type=script&lang=ts"

import "./AppPaymentsTable.vue?vue&type=style&index=0&id=51ed75a6&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__